import React, { createContext, useContext } from 'react';
import { useQuery } from '@apollo/client';
import { useListenForUserProfilePrivacyUpdate } from '../UserProfileCompletionItem/hooks/useListenForUserProfilePrivacyUpdate.es.js';
import { useListenForUserProfileCompletionUpdate } from '../UserProfileCompletionItem/hooks/useListenForUserProfileCompletionUpdate.es.js';
import { useListenForUserWorkAvailabilityUpdate } from '../UserWorkAvailabilityItem/hooks/useListenForUserWorkAvailabilityUpdate.es.js';
import { ProfileQueryDefinition } from './queries.es.js';

var InitialState = {
  data: undefined,
  isLoading: false,
  error: undefined
};
var ProfileProviderContext = createContext(InitialState);
var ProfileProvider = function ProfileProvider(_ref) {
  var children = _ref.children;
  var _useQuery = useQuery(ProfileQueryDefinition),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  useListenForUserProfilePrivacyUpdate();
  useListenForUserProfileCompletionUpdate();
  useListenForUserWorkAvailabilityUpdate();
  return /*#__PURE__*/React.createElement(ProfileProviderContext.Provider, {
    value: {
      isLoading: loading,
      error: error,
      data: data
    }
  }, children);
};
var useProfileProviderContext = function useProfileProviderContext() {
  return useContext(ProfileProviderContext);
};

export { InitialState, ProfileProvider, ProfileProviderContext, useProfileProviderContext };
